import { Slide } from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";
import { forwardRef } from "react";
import type { ReactElement, Ref } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TransitionSlideUp: any | undefined = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// eslint-disable-next-line react-refresh/only-export-components
export const spinningAnimation = { animation: "spin 4s linear infinite" };
